import React, { type FC } from 'react';
import type { List } from 'immutable';

import type { RecordOfStakeEntity } from 'app/lib/betting/betting-entities';

import SlotStake from './SlotStake';

type CorrectScoreProps = {
  stakes: List<RecordOfStakeEntity>;
};

const DefaultSlotContentComponent: FC<CorrectScoreProps> = ({ stakes }) => {
  return (
    <>
      {stakes.map((stake) => (
        <SlotStake stake={stake}
                   key={stake.id} />
      ))}
    </>
  );
};

export default DefaultSlotContentComponent;
